import { defineMessages } from 'react-intl';

export const messages: {
	tellAILabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	tellAgentLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	suggestionStatusBeta: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	suggestionStatusNew: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	tellAILabel: {
		id: 'fabric.editor.ai.ui.components.suggestions.tellAILabel',
		defaultMessage: 'Tell AI',
		description:
			'Label for the default free-text input suggestion option in the AI suggestions panel, allowing users to type a custom prompt to send to the AI.',
	},
	tellAgentLabel: {
		id: 'fabric.editor.ai.ui.components.suggestions.tellAgentLabel',
		defaultMessage: 'Tell Agent',
		description:
			'Label for the agent-specific suggestion option in the AI suggestions panel, allowing users to direct a custom prompt to the Rovo Agent.',
	},
	suggestionStatusBeta: {
		id: 'fabric.editor.ai.ui.components.suggestions.betaLozenge',
		defaultMessage: 'BETA',
		description: 'Lozenge text to indicate that the feature is in beta stage',
	},
	suggestionStatusNew: {
		id: 'fabric.editor.ai.ui.components.suggestions.newLozenge',
		defaultMessage: 'NEW',
		description: 'Lozenge text to indicate that the feature is in new',
	},
});
